import React from 'react';
import HelpLink from '~/components/Links/HelpLink';
import ListFlowBaseDescription from '~/components/ListFlow/Descriptions/ListFlowBaseDescription';

interface Props {}

const ListFlowShippingDescription: React.FC<Props> = () => (
  <ListFlowBaseDescription
    title="We make shipping easy"
    bulletItems={[
      <span key={1}>
        We strongly encourage sellers to use our suggested weight and
        dimensions.
      </span>,
      <span key={2}>
        After your item sells, you’ll receive a prepaid shipping label.
      </span>,
      <span key={3}>
        Offer a shipping discount to sell your items even faster
      </span>,
    ]}
    postContent={
      <div>
        <HelpLink link="shipping" className="font-semibold underline">
          Learn more about how shipping works
        </HelpLink>
      </div>
    }
  />
);

export default ListFlowShippingDescription;
